__turbopack_context__.v({
  "buttonClose": "Modal-module__aCX8gq__buttonClose",
  "icon": "Modal-module__aCX8gq__icon",
  "modal": "Modal-module__aCX8gq__modal",
  "noCloseButton": "Modal-module__aCX8gq__noCloseButton",
  "onlyVertical": "Modal-module__aCX8gq__onlyVertical",
  "overlay": "Modal-module__aCX8gq__overlay",
});
